import React from "react";

const Inplay = React.lazy(() =>
  import("./components/admin/quick_links/inplay/Inplay"),
);

const Market_Analysis = React.lazy(() =>
  import("./components/admin/quick_links/market_analysis/Market_Analysis"),
);

// Roles
const Roles = React.lazy(() =>
  import("./components/admin/roles/roles/Roles.js"),
);

// Management
const Super_Super_Master = React.lazy(() =>
  import("./components/admin/management/super_super_master/Super_Super_Master"),
);

const Super_Master = React.lazy(() =>
  import("./components/admin/management/super_master/Super_Master"),
);

const Master = React.lazy(() =>
  import("./components/admin/management/master/Master"),
);

const Client = React.lazy(() =>
  import("./components/admin/management/client/Client"),
);

const Inspect_User = React.lazy(() =>
  import("./components/admin/management/inspect_user/Inspect_User"),
);

const Profit_Loss_Analysis = React.lazy(() =>
  import(
    "./components/admin/profit_and_loss/profit_loss_analysis/Profit_Loss_Analysis"
  ),
);

const Match = React.lazy(() => import("./components/admin/sports/match/Match"));

const Match_Details = React.lazy(() =>
  import("./components/admin/sports/match_details/Match_Details"),
);

// profile section

// const My_Account = React.lazy(() =>
//   import("./components/admin/profile/my_account/My_Account"),
// );

// const My_Wallet = React.lazy(() =>
//   import("./components/admin/profile/my_wallet/My_Wallet"),
// );

// const Bid_History = React.lazy(() =>
//   import("./components/admin/profile/bid_history/Bid_History"),
// );

// const Profit_Loss = React.lazy(() =>
//   import("./components/admin/profile/profit_loss/Profit_Loss"),
// );

const Statement = React.lazy(() =>
  import("./components/admin/profile/statement/Statement"),
);

const AllStatement = React.lazy(() =>
  import("./components/admin/profile/all_statement/AllStatement.js"),
);

const Completedbets = React.lazy(() =>
  import("./components/admin/profile/completedbets/Completedbets.js"),
);

const AllCompletedbets = React.lazy(() =>
  import("./components/admin/profile/allcompletedbets/AllCompletedbets.js"),
);

const AllCommission = React.lazy(() =>
  import("./components/admin/profile/allcommission/AllCommission.js"),
);

const Settlement = React.lazy(() =>
  import("./components/admin/profile/settlement/Settlement.js"),
);

const AllSettlement = React.lazy(() =>
  import("./components/admin/profile/all_settlement/AllSettlement.js"),
);

const Manage_General = React.lazy(() =>
  import("./components/admin/profile/manage_general/Manage_General"),
);

const Commission_Report = React.lazy(() =>
  import("./components/admin/profile/commision_report/Commision_Report"),
);

const Rules = React.lazy(() =>
  import("./components/admin/profile/rules/Rules"),
);

const Activities = React.lazy(() =>
  import("./components/admin/profile/activities/Activities"),
);

const Mobile_Profile_Component = React.lazy(() =>
  import(
    "../src/layout/main/app_header/mobile_profile_component/Mobile_Profile_Component"
  ),
);

// Policy
const PolicyRules = React.lazy(() =>
  import("./components/admin/policy/rules/Rules.js"),
);

const PolicyTAndC = React.lazy(() =>
  import("./components/admin/policy/t_and_c/TAndC.js"),
);

const PolicyPrivacy = React.lazy(() =>
  import("./components/admin/policy/privacy/Privacy.js"),
);

// Masters
const MastersAppSetup = React.lazy(() =>
  import("./components/admin/masters/app_setup/AppSetup.js"),
);
const MastersBetButton = React.lazy(() =>
  import("./components/admin/masters/bet_buttons/BetButton.js"),
);
const MastersTypes = React.lazy(() =>
  import("./components/admin/masters/types/Types.js"),
);

const MastersBetSettlement = React.lazy(() =>
  import("./components/admin/masters/bets_settlement/BetSettlement.js"),
);

const MastersJournalEntries = React.lazy(() =>
  import("./components/admin/masters/journal_entries/JournalEntries.js"),
);

const MastersSocialMedia = React.lazy(() =>
  import("./components/admin/masters/social_media/SocialMedia.js"),
);

const MastersContactUs = React.lazy(() =>
  import("./components/admin/masters/contact_us/ContactUs.js"),
);

const MastersState = React.lazy(() =>
  import("./components/admin/masters/state/State.js"),
);

const MastersBanner = React.lazy(() =>
  import("./components/admin/masters/banner/Banner.js"),
);

const MastersBigWin = React.lazy(() =>
  import("./components/admin/masters/bigwin/Bigwin.js"),
);

const MastersAgent = React.lazy(() =>
  import("./components/admin/masters/agent/Agent.js"),
);

const MastersLeaderboard = React.lazy(() =>
  import("./components/admin/masters/leaderboard/Leaderboard.js"),
);



// Wallets
const WalletFundRequest = React.lazy(() =>
  import("./components/admin/wallets/fund/FundRequest.js"),
);
const WalletFundAccept = React.lazy(() =>
  import("./components/admin/wallets/fund/FundAccept.js"),
);
const WalletFundReject = React.lazy(() =>
  import("./components/admin/wallets/fund/FundReject.js"),
);
const WalletWithdrawRequest = React.lazy(() =>
  import("./components/admin/wallets/withdraw/WithdrawRequest.js"),
);
const WalletWithdrawAccept = React.lazy(() =>
  import("./components/admin/wallets/withdraw/WithdrawAccept.js"),
);
const WalletWithdrawReject = React.lazy(() =>
  import("./components/admin/wallets/withdraw/WithdrawReject.js"),
);

const routes = [
  { path: "/", exact: true, name: "Home", element: Inplay },
  { path: "/quick-link/inplay", name: "Inplay", element: Inplay },
  {
    path: "/quick-link/market-analysis",
    name: "Market_Analysis",
    element: Market_Analysis,
  },
  {
    path: "/roles/roles-permissions",
    name: "Roles",
    element: Roles,
  },

  {
    path: "/management/super-super-master",
    name: "Super_Super_Master",
    element: Super_Super_Master,
  },
  {
    path: "/management/super-master",
    name: "Super_Master",
    element: Super_Master,
  },
  { path: "/management/master", name: "Master", element: Master },
  { path: "/management/client", name: "Client", element: Client },
  {
    path: "/management/inspect-user",
    name: "Inspect_User",
    element: Inspect_User,
  },

  {
    path: "/p-l/profit-loss-analysis",
    name: "Inspect_User",
    element: Profit_Loss_Analysis,
  },

  {
    path: "/sports/match/:competition_id",
    name: "Match",
    element: Match,
  },
  {
    path: "/sports/match/match-details/:competition_id/:id",
    name: "Match_Details",
    element: Match_Details,
  },

  // { path: "/profile/my-account", name: "My Account", element: My_Account },
  // { path: "/profile/my-wallet", name: "Wallet", element: My_Wallet },
  // { path: "/profile/bid-history", name: "Bid History", element: Bid_History },
  // { path: "/profile/profit-loss", name: "Profit & Loss", element: Profit_Loss },

  { path: "/profile/statement", name: "Statement", element: Statement },
  {
    path: "/profile/all-statement",
    name: "All Statement",
    element: AllStatement,
  },
  {
    path: "/profile/completed-bets",
    name: "Completed Bets",
    element: Completedbets,
  },
  {
    path: "/profile/all-completed-bets",
    name: "All Completed Bets",
    element: AllCompletedbets,
  },
  {
    path: "/profile/all-commission",
    name: "All Commission",
    element: AllCommission,
  },
  { path: "/profile/settlement", name: "Settlement", element: Settlement },
  {
    path: "/profile/all-settlement",
    name: "All Settlement",
    element: AllSettlement,
  },
  {
    path: "/profile/manage-general",
    name: "Manage_General",
    element: Manage_General,
  },
  {
    path: "/profile/commission-report",
    name: "Commission_Report",
    element: Commission_Report,
  },
  { path: "/profile/rules", name: "Commission_Report", element: Rules },
  { path: "/profile/activities", name: "Activities", element: Activities },

  {
    path: "/my-profile",
    name: "Activities",
    element: Mobile_Profile_Component,
  },

  // profile routes

  // { path: "/profile/my-account", name: "Inspect_User", element: My_Account },
  // { path: "/profile/my-wallet", name: "Inspect_User", element: My_Wallet },
  // { path: "/profile/bid-history", name: "Inspect_User", element: Bid_History },
  // { path: "/profile/profit-loss", name: "Inspect_User", element: Profit_Loss },

  // Policys

  {
    path: "/policy/rules",
    name: "Rules",
    element: PolicyRules,
  },
  {
    path: "/policy/t-and-c",
    name: "T And C",
    element: PolicyTAndC,
  },
  {
    path: "/policy/privacy",
    name: "Privacy",
    element: PolicyPrivacy,
  },

  // Masters
  {
    path: "/masters/app-setup",
    name: "App Setup",
    element: MastersAppSetup,
  },
  {
    path: "/masters/bet-buttons",
    name: "Bet Button",
    element: MastersBetButton,
  },
  {
    path: "/masters/types",
    name: "Types",
    element: MastersTypes,
  },
  {
    path: "/masters/journal-entries",
    name: "Journal Entries",
    element: MastersJournalEntries,
  },
  {
    path: "/masters/social-media",
    name: "Social Media",
    element: MastersSocialMedia,
  },
  {
    path: "/masters/contact-us",
    name: "Contact Us",
    element: MastersContactUs,
  },
  {
    path: "/masters/state",
    name: "State",
    element: MastersState,
  },
  {
    path: "/masters/banner",
    name: "Banner",
    element: MastersBanner,
  },
  {
    path: "/masters/bigwin",
    name: "Big Win",
    element: MastersBigWin,
  },
  {
    path: "/masters/agent",
    name: "Agent",
    element: MastersAgent,
  },
  {
    path: "/masters/leaderboard",
    name: "Leaderboard",
    element: MastersLeaderboard,
  },

  {
    path: "/masters/bet-settlement",
    name: "Bet Settlement",
    element: MastersBetSettlement,
  },
  // Wallets
  {
    path: "/wallets/fund-requests",
    name: "Fund Request",
    element: WalletFundRequest,
  },
  {
    path: "/wallets/fund-accepts",
    name: "Fund Accept",
    element: WalletFundAccept,
  },
  {
    path: "/wallets/fund-rejects",
    name: "Fund Reject",
    element: WalletFundReject,
  },
  {
    path: "/wallets/withdraw-requests",
    name: "Withdraw Request",
    element: WalletWithdrawRequest,
  },
  {
    path: "/wallets/withdraw-accepts",
    name: "Withdraw Request",
    element: WalletWithdrawAccept,
  },
  {
    path: "/wallets/withdraw-rejects",
    name: "Withdraw Reject",
    element: WalletWithdrawReject,
  },
];

export default routes;
